import React from "react";
import {useTranslation} from "react-i18next";
import {inject, observer} from "mobx-react";
// local
import OverviewManualCardView from "../../OverviewCard/OverviewManualCardView";
import PresentationCardWrapper from "../../PresentationCardWrapper";
import PoliciesEdit from "./PoliciesEdit";
import EmptyData from "components/EmptyData";
import {IconPaperPencil} from "components/icons";
import {LockValue} from "components/LockValue";

const Policies = inject("store")(
  observer(({store: {organization}, edit, setEdit}) => {
    const {t} = useTranslation();
    const {organizationDetail} = organization;
    const closeEdit = () => setEdit({...edit, policies: false});

    if (edit.policies) return <PoliciesEdit closeEdit={closeEdit} />;

    const mapData = () =>
      !!organizationDetail?.Policies?.length &&
      organizationDetail.Policies.map((item) => (
        <OverviewManualCardView
          key={item.id}
          firstParameter={item.name}
          files={item.Files}
        />
      ));

    return (
      <PresentationCardWrapper
        icon={<IconPaperPencil />}
        title={t("POLICIES")}
        edit={edit}
        setEdit={setEdit}
        editName="policies"
        editPermissions={["EDIT_OUR_PROFILE_MAIN_INFO"]}
        isActive={organizationDetail?.isActive}
      >
        <LockValue
          canPermissions={["READ_OTHER_POLICIES"]}
          noHideOurInfo
          fullSubcribeButton
          needMiniSibscribeButton
        >
          <>{mapData() || <EmptyData />}</>
        </LockValue>
      </PresentationCardWrapper>
    );
  })
);

export default Policies;
